module.exports = __webpack_public_path__ + "static/social-preview-408a20d1be7591fd6fe7ef5087f0e78d.jpg";